/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useSsoTabStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  switchContainer: {
    marginLeft: '4px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '10px',
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  helperText: {
    '& .MuiFormHelperText-root': {
      padding: '0 0 0 5px',
    },
  },
  switchHint: {
    color: 'rgba(0,0,0,0.6)',
    marginTop: '-5px',
    marginLeft: '28px',
  },
  domainsRoot: {
    marginTop: '20px',
  },
  domainsError: {
    color: `${theme.palette.error.main} !important`,
  },
  domainsHint: {
    fontSize: '12px',
    lineHeight: '16px',
    color: 'rgba(0,0,0,0.6)',
    paddingLeft: '5px',
  },
  domains: {
    marginLeft: '5px',
  },
  domain: {
    marginTop: '10px',
    display: 'flex',
    gap: '5px',
  },
}));
